import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=9c4b0640"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c4b0640')) {
      api.createRecord('9c4b0640', component.options)
    } else {
      api.reload('9c4b0640', component.options)
    }
    module.hot.accept("./Role.vue?vue&type=template&id=9c4b0640", function () {
      api.rerender('9c4b0640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/Role.vue"
export default component.exports